<template>
    <div>
    <v-data-table v-if="dashboardType === 'details'" :headers="tableHeaders" :items="visibleReports" hide-default-footer :server-items-length="totalReports"
        @item-selected="handleSelect" @toggle-select-all="handleSelectAll" :loading-text="$t('loadingData')" :loading="reportsLoading">
            <template v-slot:top="{ }">
                <!-- title  -->
                <h3 class="text-h6 mb-4">
                    {{ $t("esgPlatform.esgReport.listOfReports") }}
                </h3>
                <div class="d-flex">
                    <v-text-field prepend-inner-icon="mdi-magnify" style="width: 300px" outlined height="5px"
                        :placeholder="$t('search')" dense v-model="options.searchPhrase" @input="handleSearch" class="shrink"
                        clearable></v-text-field>

                    <v-spacer></v-spacer>
                      <!-- View Toggle -->
                    <div class="d-flex mr-5">
                    <v-btn color="primary" dark class="rounded-r-0" outlined @click="dashboardType = 'details'" >
                        <v-icon :color="dashboardType === 'details' ? 'primary' : 'gray'">mdi-menu</v-icon>
                    </v-btn>
                    <v-btn color="primary" dark class="rounded-l-0" outlined style="margin-left: -1px" @click="dashboardType = 'chart'">
                        <v-icon :color="dashboardType === 'chart' ? 'primary' : 'gray'">mdi-view-grid</v-icon>
                    </v-btn>
                    </div>

                    <div class="py-1 title">
                        {{ options.page }} - {{ totalPages }} {{ $t("of") }}
                        {{ totalReports }}
                    </div>
                    <v-btn class="mx-2" fab small outlined color="primary" :disabled="options.page <= 1"
                        @click="pageChange(false)">
                        <v-icon dark> mdi-chevron-left </v-icon>
                    </v-btn>
                    <v-btn class="mx-2" fab small outlined color="primary" :disabled="options.page >= totalPages"
                        @click="pageChange(true)">
                        <v-icon dark> mdi-chevron-right </v-icon>
                    </v-btn>
                    <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" left :min-width="417">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mx-2" fab small outlined color="primary" v-bind="attrs" v-on="on">
                                <v-icon dark> mdi-cog-outline</v-icon>
                            </v-btn>
                        </template>
                        <v-card width="417">
                            <v-list>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>{{
                                            $t("deforestation.customization")
                                        }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                                <div class="pl-3 pt-2 font-weight-normal">
                                    {{ $t("deforestation.recordsPerpage") }}
                                </div>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-slider v-model="itemsPerPage" :tick-labels="itemsPerPageOptions"
                                            :max="3" step="1" ticks="always" tick-size="4"></v-slider>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-n3"></v-divider>
                            </v-list>
                            <v-card-text>
                                <v-container fluid>
                                    <v-row>
                                        <v-col class="mt-n9" cols="6" v-for="header in headers" :key="header.value">
                                            <v-checkbox v-if="header.text" v-model="selectedHeaders"
                                                :label="header.text" color="primary" :value="header.text" hide-details
                                                :disabled="header.text == 'ID'"></v-checkbox>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-layout justify-center>
                                <v-card-actions class="mb-5">
                                    <v-spacer></v-spacer>

                                    <v-btn outlined color="primary" @click="resetDefaut" width="190">
                                        {{ $t("deforestation.restoreDefault") }}
                                    </v-btn>
                                    <v-btn color="primary" @click="resetTableStructure" width="190">
                                        {{ $t("deforestation.apply") }}
                                    </v-btn>
                                </v-card-actions>
                            </v-layout>
                        </v-card>
                    </v-menu>

                </div>

            </template>
            <!-- Report Columns -->
            <template v-slot:item.reportId="{ item }">
                <span class="font-weight-medium">{{ item.reportId || "N/A" }}</span>
            </template>
            <template v-slot:item.template="{ item }">
                {{ item.reportId }}
            </template>
            <template v-slot:item.reportType="{ item }">
                <span>{{ reportTypeLabel(item.reportType) }}</span>
            </template>
            <template v-slot:item.dateGenerated="{ item }">
                {{ getDateFormat( item.dateGenerated ) }}
            </template>
            <template v-slot:item.status="{ item }">
                <div class="d-flex justify-start align-center" style="width: 100%;">
                    <v-chip :color="statusColor(item.status)" outlined class="d-flex justify-center align-center w-100"
                        style="width: 100%;">
                        {{ statusLabel(item.status) }}
                    </v-chip>
                </div>
            </template>
            <template v-slot:item.action="{ item }">
                <v-menu location="start">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item>
                            <v-list-item-title class="cursor-pointer" @click="viewReport(item)">
                                {{ $t("esgPlatform.esgReport.view") }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title class="cursor-pointer" @click="editReport(item)">
                                {{ $t("esgPlatform.esgReport.edit") }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title class="cursor-pointer" @click="openDownloadDialog(item)">{{
                                $t("esgPlatform.esgReport.download")
                                }}</v-list-item-title>
                        </v-list-item>
                        <!-- copy and create   new report -->
                        <v-list-item>
                            <v-list-item-title class="cursor-pointer" @click="copyAndCreateNew(item)">{{
                                $t("esgPlatform.esgReport.copyAndCreateNew")
                                }}</v-list-item-title>
                        </v-list-item>
                        <!-- delete  -->
                        <v-list-item>
                            <v-list-item-title class="cursor-pointer red--text"
                                @click="confirm = true; confirmElements.confirmData = item">
                                {{ $t("esgPlatform.esgReport.delete") }}
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
            <template v-slot:footer></template>
        </v-data-table>

        <!-- Grid View -->
        <div v-else>
            <!-- Header Section -->
            <div>
                <h3 class="text-h6 black--text mb-4">{{ $t("esgPlatform.esgReport.gridOfReports") }}</h3>
                <div class="d-flex mb-4">
                    <v-text-field prepend-inner-icon="mdi-magnify" style="width: 300px" outlined height="5px"
                        :placeholder="$t('search')" dense v-model="options.searchPhrase" @input="handleSearch" class="shrink"
                        clearable></v-text-field>

                    <v-spacer></v-spacer>
                    <!-- View Toggle -->
                    <div class="d-flex mr-5">
                        <v-btn color="primary" dark class="rounded-r-0" outlined @click="dashboardType = 'details'" >
                            <v-icon :color="dashboardType === 'details' ? 'primary' : 'gray'">mdi-menu</v-icon>
                        </v-btn>
                        <v-btn color="primary" dark class="rounded-l-0" outlined style="margin-left: -1px" @click="dashboardType = 'chart'">
                            <v-icon :color="dashboardType === 'chart' ? 'primary' : 'gray'">mdi-view-grid</v-icon>
                        </v-btn>
                    </div>

                    <div class="py-1 black--text title">{{ options.page }} - {{ totalPages }} {{ $t("of") }} {{ totalReports }}</div>
                    <v-btn class="mx-2" fab small outlined color="primary" :disabled="options.page <= 1" @click="pageChange(false)">
                        <v-icon dark> mdi-chevron-left </v-icon>
                    </v-btn>
                    <v-btn class="mx-2" fab small outlined color="primary" :disabled="options.page >= totalPages" @click="pageChange(true)">
                        <v-icon dark> mdi-chevron-right </v-icon>
                    </v-btn>
                    <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" left :min-width="417">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mx-2" fab small outlined color="primary" v-bind="attrs" v-on="on">
                                <v-icon dark> mdi-cog-outline</v-icon>
                            </v-btn>
                        </template>
                        <v-card width="417">
                            <v-list>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>{{$t("deforestation.customization")}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                                <div class="pl-3 pt-2 font-weight-normal">{{ $t("deforestation.recordsPerpage") }}</div>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-slider v-model="itemsPerPage" :tick-labels="itemsPerPageOptions"
                                            :max="3" step="1" ticks="always" tick-size="4"></v-slider>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                            <v-layout justify-center>
                                <v-card-actions class="mb-5">
                                    <v-spacer></v-spacer>
                                    <v-btn outlined color="primary" @click="resetDefaut" width="190">
                                        {{ $t("deforestation.restoreDefault") }}
                                    </v-btn>
                                    <v-btn color="primary" @click="updateLimit(); menu = false" width="190">
                                        {{ $t("deforestation.apply") }}
                                    </v-btn>
                                </v-card-actions>
                            </v-layout>
                        </v-card>
                    </v-menu>
                </div>
            </div>

            <!-- Grid Cards -->
            <v-row v-if="!reportsLoading">
                <v-col v-for="item in visibleReports" :key="item._id" cols="12" sm="6" md="4" lg="3">
                    <v-card class="report-card" outlined hover>
                        <v-card-text class="pb-0">
                            <!-- Report ID -->
                            <div class="text-h6 font-weight-bold mb-4 black--text">
                                {{ item.templateId?.templateName || "N/A" }}
                            </div>
                            
                            <!-- Template -->
                            <div class="mb-2">
                                <span class="text-caption font-weight-bold grey--text text--darken-1">{{$t("esgPlatform.esgReport.reportId")}}:</span>
                                <div class="text-body-2">{{ item.reportId || "N/A" }}</div>
                            </div>

                            <!-- Access Type -->
                            <div class="mb-2">
                                <span class="text-caption font-weight-bold grey--text text--darken-1">{{ $t("esgPlatform.esgReport.access") }}:</span>
                                <div class="text-body-2">{{ reportTypeLabel(item.reportType) }}</div>
                            </div>

                            <!-- Date -->
                            <div class="mb-4">
                                <span class="text-caption font-weight-bold grey--text text--darken-1">{{ $t("esgPlatform.esgReport.dateGenerated") }}:</span>
                                 <div class="text-body-2">{{ getDateFormat( item.dateGenerated ) }}</div>
                            </div>

                            <!-- Status -->
                        </v-card-text>
                        
                        <!-- Actions Menu at Bottom Right -->
                        <v-card-actions class="pt-0">
                            <div class="ml-2">
                                <v-chip :color="statusColor(item.status)" outlined small>{{ statusLabel(item.status) }}</v-chip>
                            </div>
                            <v-spacer></v-spacer>
                            <v-menu offset-y left>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="my-green" icon v-bind="attrs" v-on="on"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                                </template>
                                <v-list>
                                    <v-list-item @click="viewReport(item)">
                                        <v-list-item-title class="cursor-pointer">{{ $t("esgPlatform.esgReport.view") }}</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="editReport(item)">
                                        <v-list-item-title class="cursor-pointer">{{ $t("esgPlatform.esgReport.edit") }}</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="openDownloadDialog(item)">
                                        <v-list-item-title class="cursor-pointer">{{ $t("esgPlatform.esgReport.download") }}</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="copyAndCreateNew(item)">
                                        <v-list-item-title class="cursor-pointer">{{ $t("esgPlatform.esgReport.copyAndCreateNew") }}</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="confirm = true; confirmElements.confirmData = item">
                                        <v-list-item-title class="cursor-pointer red--text">{{ $t("esgPlatform.esgReport.delete") }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>

            <!-- Loading State -->
            <div v-else class="text-center py-12">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                <div class="mt-4">{{ $t('loadingData') }}</div>
            </div>

            <!-- Empty State -->
            <div v-if="!reportsLoading && visibleReports.length === 0" class="text-center py-12">
                <v-icon size="64" color="grey lighten-1">mdi-file-document-outline</v-icon>
                <div class="text-h6 grey--text mt-4">{{$t('esgPlatform.esgReport.noReportFound')}}</div>
            </div>
        </div>

        <confirm-box :title="confirmElements.title" :message="confirmElements.message"
            :cancelBtnText="confirmElements.cancelBtnText" :confirmBtnText="confirmElements.confirmBtnText"
            :confirmData="confirmElements.confirmData" :dialog="confirm" @cancel:action="confirm = false"
            @continue:action="deleteReport"></confirm-box>
        <DownloadConfirmDialog v-model="showDownloadDialog" :item="selectedItem" @download="handleDownload" />
    </div>
</template>
<script>
import _ from "lodash";
import ConfirmBox from "@/components/ConfirmBox.vue";
import DownloadConfirmDialog from '../components/download-confirm.vue';
import EsgService from "../../../../_services/EsgService";
import LoadingMixin from "@/mixins/LoadingMixin";
import { formatLocaleDate } from "@/utils/localeFormat";

export default {
    components: { ConfirmBox, DownloadConfirmDialog },
    mixins: [LoadingMixin],
    props: {
        toggleSelection: {
            type: Boolean,
        },
        toggleFilterState: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        reports(newReports) {
            this.localReports = newReports;
        },
    },
    computed: {
        totalPages() {
            return this.totalReports < this.options.limit
                ? 1
                : Math.ceil(this.totalReports / this.options.limit);
        },
        dateRangeText() {
            return this.options.date.join(" - ");
        },
    },
    data() {
        return {
            dashboardType: "details",
            fromProjects: 0,
            visibleReports: [],
            allReports: [],
            usableReports: [],
            reportsLoading: true,
            totalReports: 0,
            itemsPerPage: 0,
            itemsPerPageOptions: [10, 25, 50, 75, 100],
            selected: [],
            menu: false,
            selectedHeaders: [],
            search: "",
            options: {
                limit: 10,
                page: 1,
                searchPhrase: "",
                date: [],
                status: "",
                orderType: "DESC",
            },
            countries: [],
            states: [],
            confirm: false,
            confirmElements: {
                title: this.$t("esgPlatform.esgReport.deleteEsgReport"),
                message: this.$t("esgPlatform.esgReport.confirmDeleteReportMessage"),
                confirmBtnText: this.$t("esgPlatform.esgReport.delete"),
                cancelBtnText: this.$t("esgPlatform.esgReport.cancel"),
                confirmData: {},
            },
            filterByDateMenu: false,
            showDownloadDialog: false,
            selectedItem: {},
            tableHeaders: [],
            headers: [
                {
                    text: this.$t("esgPlatform.esgReport.reportId"),
                    align: "start",
                    value: "reportId",
                    class: "black--text",
                },
                {
                    text: this.$t("esgPlatform.esgReport.template"),
                    align: "start",
                    value: "templateId.templateName",
                    class: "black--text",
                },
                {
                    text: this.$t("esgPlatform.esgReport.access"),
                    align: "start",
                    value: "reportType",
                    class: "black--text",
                },
                {
                    text: this.$t("esgPlatform.esgReport.dateGenerated"),
                    align: "start",
                    value: "dateGenerated",
                    class: "black--text",
                },
                {
                    text: this.$t("esgPlatform.esgReport.status"),
                    align: "center",
                    value: "status",
                    class: "black--text",
                },
                {
                    text: '',
                    align: "start",
                    value: "action",
                    class: "black--text",
                }
            ],
        };
    },
    async created() {
        try {
            const { data } = await EsgService.getEsgReports();
            this.allReports = data.reverse();
            this.usableReports = this.allReports;
            this.initializeData();
        } catch(e) {
            this.$notify({
                type: "error",
                text: "Failed to load ESG Reports"
            });
        } finally {
            this.reportsLoading = false;
        }
    },
    async mounted() {
    this.tableHeaders = this.headers;
    this.selectedHeaders = this.headers.map(h => h.text).filter(Boolean);
    },
    methods: {
        editReport(item) {
            this.$router.push({
            name: 'createNewEsgReport',
            query: { reportId: item._id, mode: 'edit' }
        });
        },
        initializeData() {
            this.totalReports = this.usableReports.length;
            this.visibleReports = this.usableReports.slice(0, this.options.limit);
            this.selectedHeaders = this.headers.map(header => header.text).filter(text => text !== 'ID');
        },
        handleSearch() {
            this.usableReports = this.allReports.filter((item) => item.reportId.toLowerCase().includes(this.options.searchPhrase.toLowerCase()));
            this.initializeData();
        },
        updateLimit() {
            // this.options.limit = this.itemsPerPage === 0 ? 10: this.itemsPerPage * 25;
            this.options.limit = this.itemsPerPageOptions[this.itemsPerPage];
            this.options.page = 1;
            this.visibleReports = this.usableReports.slice(0, this.options.limit);
        },
        viewReport(item) {
            this.$router.push({
                name: 'createNewEsgReport',
                query: { reportId: item._id }
            });
        },
        statusColor(status) {
            if (status === "Saved") return "grey";
            if (status === "Publishing to Blockchain") return "orange";
            if (status === "Published to Blockchain") return "green";
            return "grey";
        },

        pageChange(t) {
            if (t) {
                this.options.page = this.options.page + 1;
            } else {
                this.options.page = this.options.page - 1;
            }
            const currentStartIndex = (this.options.page - 1) * this.options.limit;
            this.visibleReports = this.usableReports.slice(currentStartIndex, currentStartIndex + this.options.limit);
        },
        openDownloadDialog(item) {
            this.selectedItem = item
            this.showDownloadDialog = true
        },
        async handleDownload(downloadData) {
            if (downloadData.format === 'pdf') {
                await this.downloadAsPDF(downloadData.item._id)
            } else if (downloadData.format === 'xlsx') {
                this.downloadAsExcel(downloadData.item._id)
            }
        },
        async downloadAsPDF(reportId) {
            this.startLoading();
            try {
                const response = await EsgService.downloadEsgReport(reportId, 'pdf');

                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `esg-report-${reportId}.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (err) {
                this.$notify({
                    type: "error",
                    message: err
                })
            } finally {
                this.stopLoading();
            }
        },
        downloadAsExcel(item) {
            // Your Excel download logic
            console.log('Downloading as Excel for item:', item);
        },
        handleSelect(item) {
            this.$emit("select-report", item);
        },
        handleSelectAll(items) {
            this.$emit("select-all-reports", items);
        },
        async copyAndCreateNew(report) {
            try {
                const newReportPayload = {
                    reportId: `ESG-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
                    reportType: report.reportType,
                    esgProtocolId: report.esgProtocolId,
                    reportTimeline: report.reportTimeline,
                    subOrganizationIds: report.subOrganizationIds,
                    templateId: report.templateId._id
                }
                const result = await EsgService.createEsgReport(newReportPayload);

                if (result?.success) {
                    this.$notify({
                        type: "success",
                        message: result.message
                    });
                    this.$router.push(`/esg-platform/create-new-esg-report?reportId=${result.data._id}`);
                } else {
                    throw new Error(result.message);
                }
            } catch (e) {
                this.$notify({
                    type: "error",
                    message: `Failed to copy report: ${e}`
                })
            }
        },
        async deleteReport () {
            try {
                const result = await EsgService.deleteEsgReport(this.confirmElements.confirmData._id);

                if (result.success) {
                    this.$notify({
                        type: "success",
                        message: result.message
                    });
                    this.$router.go(0);
                } else {
                    throw new Error(result.message);
                }
            } catch (e) {
                this.$notify({
                    type: "error",
                    message: `Failed to delete report: ${e}`
                })
            } finally {
                this.confirm = false;
            }
        },
        resetTableStructure() {
            this.tableHeaders = this.headers.filter((header) =>
            (header.text && this.selectedHeaders.includes(header.text)) ||
            (!header.text));
            this.updateLimit()
            this.menu = false;
        },
        resetDefaut() {
    //     this.selectedHeaders = this.headers.map(header => header.text).filter(text => text !== 'ID');
            this.tableHeaders = this.headers;
            this.selectedHeaders = this.headers.map(header => header.text).filter(Boolean);
            this.itemsPerPage = 0;
            this.updateLimit();
            this.menu = false;
        },
        getDateFormat(date) {
            return formatLocaleDate(date);
        },
        enumLabel(group, value) {
            if (!value) return "N/A";
            const key = `esgPlatform.esgReport.${group}.${value}`;
            return this.$te(key, "en") ? this.$t(key) : value;
        },
        reportTypeLabel(reportType) {
            return this.enumLabel("accessTypes", reportType);
        },
        statusLabel(status) {
            return this.enumLabel("statuses", status);
        },
    },
    // mixins: [loadingMixin, DownloadMixin],
};
</script>

<style scoped>
.report-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    transition: all 0.3s ease; 
    border-radius: 20px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.report-card:hover {
    box-shadow: 0 10px 12px rgba(0, 0, 0, 0.15);
    transform: scale(1.03); 
}
.cursor-pointer {
    cursor: pointer;
}
.my-green {
  margin-right: -8px;
  margin-bottom: -8px;
  background-color: #00bd73 !important;
  color: white !important;
  border-radius: 10px 0px 10px 0px !important;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2) !important;
  transition: 0.2s ease-in-out;
}
.my-green:hover {
  background-color: #027549 !important;
}
</style>